// Вендоры
import 'normalize.css';
import './assets/vendors/slick-1.8.1/slick/slick.scss';
import './assets/vendors/slick-1.8.1/slick/slick-theme.scss';
import hcOffcanvasNav from 'hc-offcanvas-nav';
window.hcOffcanvasNav = hcOffcanvasNav;
// import '/node_modules/hc-offcanvas-nav/dist/hc-offcanvas-nav.css';
// import '/node_modules/hc-offcanvas-nav/src/scss/hc-offcanvas-nav.scss';
import '/node_modules/hc-offcanvas-nav/src/scss/hc-offcanvas-nav.carbon.scss';

// Шрифты
import './assets/fonts/dindisplaypro/font-stylesheet.css';

// Миксины
import './views/mixins/mixins.scss';

// Стили для сайта
import './assets/styles/style.scss';

// Модули нашего проекта
import './views/components/buttons/button.scss';
import './views/components/banners/banner.scss';
import './views/components/our-tarifs/our-tarifs.scss';
import './views/components/cart-tarif/cart-tarif.scss';
import './views/components/price-per/price-per.scss';
import './views/components/gold-partner/gold-partner.scss';
import './views/components/communication-quality/communication-quality.scss';
import './views/components/become-subscriber/become-subscriber.scss';
import './views/components/video-and-text/video-and-text.scss';
import './views/components/youtube-block/youtube-block.scss';
import './views/components/special-offers/special-offers.scss';
import './views/components/cart-offer/cart-offer.scss';
import './views/components/map/map.scss';
import './views/components/social/social.scss';
import './views/components/know-more/know-more.scss';
import './views/components/feedbacks/feedbacks.scss';
import './views/components/advantages/advantages.scss';
import './views/components/info-to-gartel/info-to-gartel.scss';
import './views/components/accardion/accardion.scss';
import './views/components/dialog/dialog.scss';
import './views/components/our-command/our-command.scss';
import './views/components/multi-stage/multi-stage.scss';
import './views/components/our-partners/our-partners.scss';
import './views/components/quests/quests-esim.scss';
import './views/components/bread-crumbs/bread-crumbs.scss';
import './views/components/our-advantages/our-advantages.scss';
import './views/components/service/service.scss';
import './views/components/tarifs/tarifs.scss';
import './views/components/feedbacks-slider/feedbacks-slider.scss';
import './views/components/test-gartel/test-gartel.scss';
import './views/components/form/form.scss';
import './views/components/footer/footer.scss';
import './views/components/header/header.scss';
import './views/components/history/history.scss';
import './views/components/our-strategy/our-strategy.scss';
import './views/components/how-much/how-much.scss';
import './views/components/transfer/transfer.scss';
import './views/components/choose-number/choose-number.scss';
import './views/components/aside-menu/aside-menu.scss';
import './views/components/list-numbers/list-numbers.scss';
import './views/components/transition/transition.scss';
import './views/components/services/services.scss';
import './views/components/tarifs-cart/tarifs-cart.scss';
import './views/components/little-stuff/little-stuff.scss';
import './views/components/another-services/another-services.scss';
import './views/components/slide-feedback/slide-feedback.scss';
import './views/components/esimvolte/esimvolte.scss';
import './views/components/pagination/pagination.scss';
import './views/components/info/info.scss';
import './views/components/cart-notification/cart-notification.scss';
import './views/components/cart-pasport/cart-pasport.scss';
// import './views/components/cart-pasport/cart-pasport.js';
import './views/components/personal-block/personal-block.scss';
import './views/components/cart-anketa/cart-anketa.scss';
import './views/components/srvs-cart/srvs-cart.scss';
import './views/components/my-select/my-select.scss';
// import './views/components/my-select/my-select.js';
import './views/components/cart-tarifs/cart-tarifs.scss';
import './views/components/cart-balance/cart-balance.scss';
import './views/components/aside-nav/aside-nav.scss';
// import './views/components/aside-nav/aside-nav.js';
import './views/components/progress/progress.scss';
// import './views/components/progress/progress.js';
import './views/components/links/link.scss';
import './views/components/modal/modal.scss';
import './views/components/arr-top/arr-top.scss';
// import './views/components/arr-top/arr-top.js';

// import './views/components/minsvyaz/minsvyaz.css';
// import './views/components/minsvyaz/minsvyaz.js';

// import './views/components/menu/menu.scss';
// import './views/components/tabs/tabs.scss';
// import './views/components/tabs/tabs.js';
// import './views/components/cart/cart.scss';
// import './views/components/cart/cart.js';

// Страницы
import './assets/styles/pages/page-unlim-ru.scss';
import './assets/styles/pages/page-contacts.scss';
import './assets/styles/pages/page-cabinet.scss';
import './views/components/pages/page-detalization.scss';
import './views/components/pages/page-articles.scss';
